import '../vendors/cookies-enabler';

export default class BannerCookie {
  constructor() {
    if (window._gTheme_.cookie_banner_enabled) {
      window.COOKIES_ENABLER.init({
        eventScroll: false,
        clickOutside: false,
        bannerHTML: window._gTheme_.cookie_banner_message
      })
    }
  }
}
